import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { Layout, PageHeader, Table, Button, message } from 'antd';
import history from '../../helpers/history';

const { Content } = Layout;

var languageMessages = window.appLocale.messages;

class ServicePage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            initLoadding: true,
            dataSource: [],

            currency: 'usd',
        }
    }

    componentWillMount() {
        this.user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};

        this.props.dispatch({ type: "action_get_payment_service", payload: { u: this.user.username } });
    }

    componentWillReceiveProps(props) {
        let { status, permission, vServices, expiration } = props;

        switch (status) {
            case 'service_success':
                permission = permission === undefined ? [] : permission;

                if (this.user.permission !== undefined) {
                    this.user.permission = permission;
                    sessionStorage.setItem("auth", JSON.stringify(this.user));
                }
                    
                this.SetServiceInfo(permission, vServices, expiration);
                break;
            case 'service_failed':
                break;
        }
    }

    //设置列表内容
    SetServiceInfo(permission, vServices, expiration) {
        var dataSource = [];
        if (vServices.length > 0) {
            let index = 1000;
            for (var kk in vServices) {
                var value = vServices[kk];

                let addOn = {};
                if (window.webType === 'US') {
                    if (value.type === 4) {
                        addOn = { key: index, name: [{ title: 'Add-on' }], intro: { items: [] }, date: '', status: [{ title: '' }], isCoupon: false, sg: 'Add-on' };
                        index++;
                    }

                    if (value.type === 3) {
                        addOn = { key: index, name: [{ title: 'MachineTrader Service' }], intro: { items: [languageMessages['service.intro']] }, date: languageMessages['Expiration'], status: [{ title: languageMessages['RemainingCredit'] }], isCoupon: false, sg: 'title' };
                        index++;
                    }
                }

                var discount = value.discount !== '' ? value.discount.split('|') : [];

                let price = value.price > 0 ? this.formatPrice(value.price) : 0;
                //let price = value.price > 0 ? value.price : 0;
                //if (value.type !== 5) price += languageMessages['yuan/month'];
                price += languageMessages['yuan/month'];

                let ins = value.ins !== '' ? value.ins.split('|') : [];
                var intro = { items: ins };

                var name = [];
                var date = '';
                var status = [];
                switch (value.type) {
                    case 0:
                        name = [{
                            title: value.title
                        }];

                        date = '---';

                        var ups = permission.filter(function (e) { return e.type === 'fs' });
                        if (ups.length > 0) {
                            var count = ups[0].totalCount - ups[0].usageCount;
                            status.push({ title: '', cont: [languageMessages['Scan'] + '：' + count + languageMessages['times']] });
                        }

                        var uph = permission.filter(function (e) { return e.type === 'fh' });
                        if (uph.length > 0) {
                            var count = uph[0].totalCount - uph[0].usageCount;
                            status.push({ title: '', cont: [languageMessages['Monitor'] + '：' + count + languageMessages['times']] });
                        }

                        break;
                    case 1:
                        var info = this.parseDiscount(discount);
                        name = [{
                            title: value.title,
                            price: price,
                            specialPrice: info,
                            button: languageMessages['buy'],
                        }];

                        var ups = permission.filter(function (e) { return e.type === 'bs' });
                        if (ups.length > 0) {
                            var count = ups[0].totalCount - ups[0].usageCount;
                            status.push({ title: '', cont: [languageMessages['Scan'] + '：' + count + languageMessages['times']] });

                            date = ups[0].expiredDate;
                        }

                        var upo = permission.filter(function (e) { return e.type === 'bh' });
                        if (upo.length > 0) {
                            var count = upo[0].totalCount - upo[0].usageCount;
                            status.push({ title: '', cont: [languageMessages['Monitor']+'：' + count + languageMessages['times']] });

                            date = upo[0].expiredDate;
                        }
                        break;
                    case 2:
                        var info = this.parseDiscount(discount);
                        name = [{
                            title: value.title,
                            price: price,
                            specialPrice: info,
                            button: languageMessages['buy'],
                        }];

                        var ups = permission.filter(function (e) { return e.type === 's1' });
                        if (ups.length > 0) {
                            var count = ups[0].totalCount - ups[0].usageCount;
                            status.push({ title: '', cont: [languageMessages['Scan'] + '：' + count + languageMessages['times']] });

                            date = ups[0].expiredDate;
                        }
                        
                        break;
                    case 3:
                        var info = this.parseDiscount(discount);
                        name = [{
                            title: value.title,
                            price: price,
                            specialPrice: info,
                            button: languageMessages['buy'],
                        }];

                        var ups = permission.filter(function (e) { return e.type === 's2' });
                        if (ups.length > 0) {
                            var count = ups[0].totalCount - ups[0].usageCount;
                            status.push({ title: '', cont: [languageMessages['Explores'] + '：' + count + languageMessages['times']] });

                            date = ups[0].expiredDate;
                        }
                        break;
                    case 4:
                        var info = this.parseDiscount(discount);
                        name = [{
                            title: value.title,
                            price: price,
                            specialPrice: info,
                            button: languageMessages['buy'],
                        }];

                        var uph = permission.filter(function (e) { return e.type === 'h' });
                        if (uph.length > 0) {
                            var count = uph[0].totalCount - uph[0].usageCount;
                            status.push({ title: '', cont: [languageMessages['Monitor'] + '：' + count + languageMessages['times']] });

                            date = uph[0].expiredDate;
                        }

                        //date = expiration !== undefined && expiration !== null ? expiration : '';
                        //status.push({ title: '' });
                        break;
                    case 5:
                        name = [{
                            title: value.title,
                            price: price,
                            button: languageMessages['buy'],
                        }];

                        date = expiration !== undefined && expiration !== null ? expiration : '';
                        status.push({ title: '' });
                        break;
                    case 6:
                        name = [{
                            title: value.title,
                            price: price,
                            button: languageMessages['buy'],
                        }];

                        date = expiration !== undefined && expiration !== null ? expiration : '';
                        status.push({ title: '' });
                        break;
                    case 7:
                        name = [{
                            title: value.title,
                            price: price,
                            button: languageMessages['buy'],
                        }];

                        date = expiration !== undefined && expiration !== null ? expiration : '';
                        status.push({ title: '' });
                        break;
                    
                }

                // 优惠券
                var couponSource = [];
                var coupon = JSON.parse(sessionStorage.getItem("CouponCache") || '{}') || {};
                if (coupon.dataSource !== undefined) {
                    couponSource = coupon.dataSource;
                }

                // 是否全场优惠券
                var universalCouponIndex = couponSource.findIndex((n) => n.type === 0);

                var isCoupon = false;
                if (value.type > 0) {
                    if (universalCouponIndex > -1) {
                        isCoupon = true;
                    } else {
                        var subscript = couponSource.findIndex((n) => n.type === value.type);
                        isCoupon = subscript > -1 ? true : false;
                    }
                }

                dataSource.push({
                    key: value.type,
                    name: name,
                    intro: intro,
                    date: date,
                    status: status,
                    isCoupon: isCoupon,
                    sg: ''
                });

                if (Object.keys(addOn).length > 0) {
                    dataSource.push(addOn);
                }
            }
        }

        this.setState({
            initLoadding: false,
            dataSource,
        });
    }

    formatPrice(amount) {
        let price = amount;//(amount / 100).toFixed(2);
        let numberFormat = new Intl.NumberFormat(['en-US'], {
            style: 'currency',
            currency: this.state.currency,
            currencyDisplay: 'symbol',
        });
        return numberFormat.format(price);
    }
    //设置第二列的折扣和优惠价
    parseDiscount(discount, isDiscount=false) {
        var info = [];
        if (discount.length > 0) {
            var strInfo = '';
            var nv = discount[0].split(';');
            if (nv.length > 0) {
                for (var n in nv) {
                    var nvs = nv[n].split(',');
                    if (nvs.length > 0) {
                        var pp1 = nvs[1];
                        if (pp1 >= 10000) {
                            pp1 = (pp1 / 10000) + languageMessages['wan'];
                        }
                        pp1 = this.formatPrice(pp1);
                        if (nvs[0] === '12') {
                            if (strInfo !== '') strInfo += '，';
                            strInfo += pp1 + languageMessages['yuan/year'];// + '(' + nvs[2] + languageMessages['discount'] + ')';
                        } else if (nvs[0] === '24') {
                            if (strInfo !== '') strInfo += '，';
                            strInfo += pp1 + languageMessages['yuan/2year'];// + '(' + nvs[2] + languageMessages['discount'] +')';
                        }
                    }
                }
                //if (isDiscount) strInfo = languageMessages['vip.special'] + '：' + strInfo;
            }
            info.push(strInfo);

            if (discount.length > 1) {
                strInfo = '';
                nv = discount[1].split(';');
                if (nv.length > 0) {
                    for (var n in nv) {
                        var nvs = nv[n].split(',');
                        if (nvs.length > 0) {
                            pp1 = this.formatPrice(nvs[1]);
                            if (nvs[0] === '12') {
                                if (strInfo !== '') strInfo += '，'
                                strInfo += pp1 + languageMessages['yuan/year'];
                            } else if (nvs[0] === '24') {
                                if (strInfo !== '') strInfo += '，'
                                strInfo += pp1 + languageMessages['yuan/2year'];
                            }
                        }
                    }
                    strInfo = languageMessages['vip.special']+'：' + strInfo;
                }
                info.push(strInfo);
            }
        }
        return info;
    }

    onBuyService = key => {
        history.push({ pathname: '/charge', state: { id: [key] } });
    }

    jumpCoupon = e => {
        history.push("/coupon");
    }

    onMyBill = e => {
        e.preventDefault();
        if (this.user.username === undefined) {
            this.props.dispatch({ type: "action_non_user" });
        } else {
            history.push({ pathname: '/member', state: { memberMenuSelectKey: "3" } });
        }
    }

    render() {
        const columns = [
            {
                title: languageMessages['service.name'],
                dataIndex: 'name',
                align: 'center',
                className: 'common-service-name',
                width: 220,
                render: (name, record) => {
                    return (<div>
                        {record.isCoupon && (<div className="coupon-conent">
                            <div className="coupon-conent-red" onClick={this.jumpCoupon}>{languageMessages['coupon']}</div>
                        </div>)}
                        {
                            name && name.map((item, index) => {
                                return <div key={index}>
                                    <b>{item.title}</b>
                                    {item.price !== undefined && (<div>{item.price}</div>)}
                                    {item.specialPrice !== undefined && (<div>{item.specialPrice}</div>)}
                                    {(item.button !== undefined) && (<div><Button size='small' style={{ width: 120 }} onClick={() => this.onBuyService(record.key)}>{item.button}</Button></div>)}
                                </div>;
                            })
                        }</div>)
                }
            }, {
                title: languageMessages['service.intro'],
                dataIndex: 'intro',
                //align: 'center',
                render: (intro, record) => {
                    var items = intro.items && intro.items.map((item, index) => {
                        return (<span key={index} style={{ display: 'block' }}>{item}</span>)
                    })
                    
                    return <div>{items}</div>;
                }
            }
        ];

        if (this.user.username !== undefined) {
            columns.push({
                title: languageMessages['Expiration'],
                dataIndex: 'date',
                //align: 'center',
                width: 150,
            });

            columns.push({
                title: languageMessages['RemainingCredit'],
                dataIndex: 'status',
                width: 300,
                //align: 'center',
                render: (status, record) => {
                    var items = status.map((item, index) => {
                        return (<div key={index}>
                            <span style={{ display: 'block' }}>{item.title}</span>
                            {item.cont && item.cont.map((ii, i) => {
                                return (<b key={i} style={{ display: 'block' }}>{ii}</b>)
                            })}
                        </div>);
                    })

                    return <div>{items}</div>;
                },
            });
        }

        return (<Content className='main-container'>
            <Helmet>
                <title>{languageMessages['title']}</title>
                <meta name="keywords" content={languageMessages['keywords']} />
                <meta name="description" content={languageMessages['description']} />

                <meta property="og:title" content={languageMessages['title']} />
                <meta property="og:url" content="https://us.quancept.com/" />
                <meta property="og:type" content="website" />
                <meta name="og:description" content={languageMessages['description']} />

                <meta property="twitter:url" content="https://us.quancept.com/" />
                <meta name="twitter:title" content={languageMessages['title']} />
                <meta name="twitter:description" content={languageMessages['description']} />
                <meta name="twitter:site" content="https://us.quancept.com/" />
            </Helmet>
                <div className='common-page-header'>
                <PageHeader title={languageMessages['please.select.service.type']}
                        extra={[
                            <Button key="1" size='small' onClick={this.onMyBill}>{languageMessages['my.account']}</Button>
                        ]} />
                </div>
            <Layout className='cont-content luis-main-content'>
                    <div style={{ margin: '10px 0 10px 10px' }}>
                        <div style={{ padding: '5px 0' }}><b>Scan</b> - Scan through all symbols in a market and find symbols that match a set of custom criteria</div>
                        <div style={{ padding: '5px 0' }}><b>Filter</b> - Monitor all symbols in a market constantly, send alert whenever any symbol meets a set of custom criteria</div>
                        <div style={{ padding: '5px 0' }}><b>Monitor</b> - Monitor a single symbol constantly for specified criteria, send alert the moment condition is met, and/or trigger order to buy or sell</div>
                        <div style={{ padding: '5px 0' }}><b>Strategy Explorer</b> - Backtest one symbol on many strategies, look for strategies with good performance for the symbol</div>
                        <div style={{ padding: '5px 0' }}><b>Backtest/Optimization</b> - Backtest one strategy on any symbol group, from one stock to the entire market; Optimize strategy for better return and lower risk</div>
                    </div>
                    <div className='common-payment-service'>
                        <Table size='small' bordered
                            rowClassName={record => {
                                let className = '';
                                if (record.sg === 'Add-on') className = 'common-table-tips ant-table-expanded-row';
                                if (record.sg === 'title') className = 'common-table-hand ant-table-expanded-row';
                                return className;
                            }}
                            columns={columns}
                            dataSource={this.state.dataSource}
                            loading={this.state.initLoadding}
                            pagination={false} />
                    </div>

                    <div style={{ margin: '20px 0', border: '1px solid #e8e8e8', padding: '16px' }}>
                        <p>
                        <span style={{ display: 'block' }}>Email: billing@quancept.com</span>
                        </p>
                    </div>
                </Layout>
        </Content>)
    }
}

function mapStateToProps(state) {
    return state.charge;
}

const page = connect(mapStateToProps)(ServicePage);
export { page as default }